import { IconPosition } from 'src/app/ui/icon/icon-types';

export enum MessageSegmentType {
  Text = 'text',
  Tip = 'tip',
  Currency = 'currency',
  Date = 'date',
}

export interface MessageSegment {
  type: MessageSegmentType;
  content: string;
  icon?: string;
  iconPosition?: IconPosition;
}

export interface StructuredHintMessage {
  id: string;
  segments: MessageSegment[];
}
